(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-gg-nav-link]');
    if (!link) return;
    var drawer = document.querySelector('header-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
    var toggle = drawer.mainDetailsToggle || drawer.querySelector('details');
    var summary = toggle && toggle.querySelector('summary');
    if (!summary) return;
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  });
})();
